import React, {useEffect, useState} from 'react';
import {Button, Flex, List, Skeleton} from "antd";
import SubCategoryPopupCard from "./SubCategoryPopupCard";
import {SubCategoryListModel, SubCategoryPopupProps} from "../../models";
import {getProductSubCategoryList, StyledPopUp} from "../../../../shared";
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {CategoryListCard} from "../index";
import categories from "../../../../shared/assets/Categories";
import {useParams} from "react-router-dom";

const SubCategoryPopup = ({open, onCansel,onSubCategoryClick ,subCategoryId,getProductSubCategoryList}: SubCategoryPopupProps) => {

    const { categoryId } = useParams();
    const allSubCategories = categories.flatMap(cat => cat.subCategories);
    const subCategory = allSubCategories.find(sub => sub.subCategoryId === Number(subCategoryId));
    const subSubCategories = subCategory?.subSubCategories || [];
    console.log(subCategoryId);
    const [subCategoryList, setSubCategoryList] =
        useState<SubCategoryListModel[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    // const getList = () => {
    //     setLoading(true);
    //     getProductSubCategoryList(categoryId)
    //         .then((data: any) => {
    //             setLoading(false)
    //             if (data.payload != undefined) {
    //
    //                 setSubCategoryList(data.payload.data);
    //
    //                 setLoading(false);
    //             } else {
    //                 setLoading(false);
    //             }
    //         })
    //         .catch((e: any) => {
    //         });
    // };
    // useEffect(() => {
    //     getList();
    // }, [categoryId]);
    return (
        <StyledPopUp
            open={open}
            onCancel={onCansel}
            title={subCategoryList[0]?.productCategoryName}
            width={"100%"}
            footer={null}
            transitionName={''}
            closable={false}
        >
            <Flex vertical gap={"small"} style={{maxHeight: "400px", overflowX: "hidden" ,overflowY: "auto"}}>

                {loading ?<Flex vertical >
                        <Skeleton round active/>

                    </Flex> :
                    <List
                        grid={{
                            gutter: 16,
                            xs: 1,
                            sm: 1,
                            md: 1,
                            lg: 1,
                            xl: 1,
                            xxl: 1,
                        }}
                        dataSource={subSubCategories}
                        renderItem={(item) => (
                            <List.Item>
                                <SubCategoryPopupCard categoryId={categoryId} title={item.name} id={item.subCategoryId} onClick={(id:number) =>onSubCategoryClick(item.name) }
                                />
                            </List.Item>
                        )}
                    />
                }

            </Flex>
        </StyledPopUp>
    );
};

export default connect(null, {getProductSubCategoryList})(withRouter(SubCategoryPopup));
